import {animate, stagger, inView, type OptionResolver} from 'motion';

class Animations {

  public init() {
    console.log('init');
  }

  colGridItems: NodeListOf<Element> | null;
  imageGridItems: NodeListOf<HTMLElement> | null;
  homeStageItem: HTMLElement | null;
  companyPartnerItems: NodeListOf<HTMLElement> | null;
  headingItems: NodeListOf<HTMLElement> | null;
  options: {
    opacity: number[];
    y: string[];
    duration: number;
    delay: OptionResolver<number>;
  };

  constructor() {
    this.colGridItems = document.querySelectorAll('body:not([class*="node-edit"]) .col-3-grid');
    this.imageGridItems = document.querySelectorAll('body:not([class*="node-edit"]) .image-grid-item');
    this.homeStageItem = document.querySelector('body:not([class*="node-edit"]) .home-stage');
    this.companyPartnerItems = document.querySelectorAll('body:not([class*="node-edit"]) .paragraph--partner-company');
    this.headingItems = document.querySelectorAll('body:not([class*="node-edit"]) .paragraph--heading');
    this.options = {
      opacity: [0, 1],
      y: ['50%', '0%'],
      duration: 0.5,
      delay: stagger(0.3),
    };
    this.createAnimations();
  }


  gridItemsAnimation() {
    const {opacity, y, duration, delay} = this.options;

    this.colGridItems?.forEach((item) => {
      const childs = item.children as unknown as NodeListOf<HTMLElement>;

      Array.from(childs).map((child: HTMLElement) => {
        child.style.opacity = '0';
      });

      inView(
        item,
        () => {
          animate(childs, {opacity, y}, {duration, delay});
        },
        {margin: '-50%'}
      );
    });
  }

  homeStageAnimation() {
    const {opacity, y} = this.options;

    if (!this.homeStageItem) return;

    Array.from(this.homeStageItem.children).map((item: HTMLElement) => {
      item.style.opacity = '0';
    });

    inView(this.homeStageItem, () => {
      const childs = this.homeStageItem.children as unknown as NodeListOf<HTMLElement>;

      animate(childs, {opacity, y}, {duration: 0.9, delay: stagger(0.5)});
    });
  }

  headingAnimation() {
    const {opacity, y, duration} = this.options;

    this.headingItems?.forEach((item) => {
      item.style.opacity = '0';

      inView(
        item,
        () => {
          animate(item, {opacity, y}, {duration});
        },
        {margin: '-20%'}
      );
    });
  }

  companyPartnerAnimation() {
    const {opacity, duration, delay} = this.options;

    this.companyPartnerItems?.forEach((item) => {
      const childs = item.children as unknown as NodeListOf<HTMLElement>;

      inView(item, () => {
        animate(childs, {opacity}, {duration, delay});
      });
    });
  }

  imageGridAnimations() {
    const {opacity, duration, delay} = this.options;

    this.imageGridItems?.forEach((item) => {
      item.style.opacity = '0';

      inView(
        item,
        () => {
          animate(item, {opacity}, {duration, delay});
        },
        {margin: '-20%'}
      );
    });
  }

  createAnimations() {
    this.gridItemsAnimation();
    this.homeStageAnimation();
    this.headingAnimation();
    this.companyPartnerAnimation();
    this.imageGridAnimations();
  }
}

const dcAnimations = new Animations();
(window as any).dcAnimations = dcAnimations;


export default dcAnimations;
